import React from 'react';
import { useField } from 'react-final-form';

import { SxProps } from '@mui/material';

import CodeMirrorJsonEditor from './CodeMirrorJsonEditor';

type Props = {
  name: string;
  sx?: SxProps;
};
export default function CodeMirrorJsonEditorField({ name, sx }: Props) {
  const { value, onChange } = useField(name).input;
  return <CodeMirrorJsonEditor defaultValue={value} onChange={onChange} sx={sx} />;
}
